export default __webpack_public_path__ + "assets/images/Creole.94b9b516.png";